import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useHealthMode } from '../context/HealthModeContext';
import { useDashboard } from '../context/DashboardContext';
import HealthToggle from './HealthToggle';
import './SideMenu.css';

interface SideMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const SideMenu: React.FC<SideMenuProps> = ({ isOpen, onClose }) => {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';
  const { healthMode, setHealthMode, canUseLloros } = useHealthMode();
  const { currentView, setCurrentView } = useDashboard();

  const handleViewChange = (view: 'dashboard' | 'analytics') => {
    setCurrentView(view);
    onClose(); // Close menu after selection
  };

  const handleHealthModeChange = (mode: 'headaches' | 'tensions' | 'lloros') => {
    setHealthMode(mode);
    onClose(); // Close menu after selection
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="side-menu-overlay" onClick={onClose} />}
      
      {/* Side Menu */}
      <div className={`side-menu ${isOpen ? 'side-menu--open' : ''}`}>
        <div className="side-menu-header">
          <h3>Menú</h3>
          <button className="side-menu-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="side-menu-content">
          {/* Dashboard Navigation - Only show if on dashboard */}
          {isDashboard && (
            <div className="side-menu-section">
              <h4>Vista</h4>
              <div className="side-menu-nav">
                <button 
                  className={`side-menu-nav-btn ${currentView === 'dashboard' ? 'active' : ''}`}
                  onClick={() => handleViewChange('dashboard')}
                >
                  📊 Principal
                </button>
                <button 
                  className={`side-menu-nav-btn ${currentView === 'analytics' ? 'active' : ''}`}
                  onClick={() => handleViewChange('analytics')}
                >
                  📈 Analytics
                </button>
              </div>
            </div>
          )}

          {/* Health Mode Selection - Only show if on dashboard */}
          {isDashboard && (
            <div className="side-menu-section">
              <h4>Modo de Salud</h4>
              <div className="side-menu-health-toggle">
                <HealthToggle
                  healthMode={healthMode}
                  onHealthModeChange={handleHealthModeChange}
                  compact={true}
                  canUseLloros={canUseLloros}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SideMenu;